/* Shared listener middleware for post-dispatch side effects, so reducers stay pure.
 *
 * Reducers must be pure state transitions: a reducer that writes to localStorage replays that
 * write every time Redux DevTools time-travel re-runs the action, and forces any test of the
 * transition to assert on storage too. Effects like persistence belong here instead.
 *
 * The type-only import of RootState avoids a runtime cycle with store.ts, which imports this
 * module to register the middleware.
 */
import { createListenerMiddleware, TypedStartListening } from '@reduxjs/toolkit';
import type { AppDispatch, RootState } from './store';

export const listenerMiddleware = createListenerMiddleware();

/** Typed `startListening`, so an effect reads RootState without casting. */
export const startAppListening = listenerMiddleware.startListening as TypedStartListening<RootState, AppDispatch>;
